import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryRedeemPoints.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const AvailMainSideSummaryRedeemPoints = class AvailMainSideSummaryRedeemPoints extends React.Component {
  static displayName = 'AvailMainSideSummaryRedeemPoints';

  render() {
    const { config, theme } = this.props,
      {
        redeemPoints
      } = config;

    const { classes } = theme.styles;

    return (
      <div className={[classes.contentModuleRow, classes.contentFlexRow].join(' ')}>
        <div className={[classes.contentModuleCell, classes.contentFlexCell].join(' ')}>
          <RichText text={'_%canjeados%_'} ucFirst={true}
                    innerStyle={['roboto16BoldBlack', 'capitalize', 'blue', 'overflowText', 'reedemPoints']}
                    translate={true} />
        </div>
        <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.contentFlexCell].join(' ')}>
          <RichText text={'-' + redeemPoints}
                    innerStyle={['roboto16BoldBlack', 'capitalize', 'blue', 'overflowText', 'reedemPoints']}
                    translate={true} />{' '}
          <RichText text={'_%puntos%_'}
                    innerStyle={['roboto16BoldBlack', 'capitalize', 'blue', 'overflowText', 'reedemPoints']}
                    translate={true} />
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'redeemPoints',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryRedeemPoints);
